export default "__VITE_ASSET__coIM$b7F__"